export default __webpack_public_path__ + "static/media/amanda_marques.6e9ffb57.jpg";